// Real Node async_hooks has no browser equivalent, and esbuild-plugin-polyfill-node's version
// throws on use ("async_hooks module is not supported by JSPM core outside of Node.js"). Server
// code (go2sim-types' request-context.ts) constructs an AsyncLocalStorage at module load time,
// so that throw would happen immediately on import - this stub keeps it inert in the browser,
// where nothing actually reads from it anyway (no requestContext.run() call exists client-side).
export class AsyncLocalStorage {
  run(store, callback) {
    return callback()
  }
  getStore() {
    return undefined
  }
}
